// extracted by mini-css-extract-plugin
module.exports = {"radioGroupWrapper":"scrolling-block_radioGroupWrapper__2uB1k"};